<script lang="ts" setup>
  import type { Space } from '../space.ts';

  withDefaults(defineProps<{ as?: string; space?: Space }>(), { as: 'div', space: 'm' });
</script>

<template>
  <component :is="as" class="stack" :data-space="space">
    <slot />
  </component>
</template>

<style scoped>
  .stack {
    display: flex;
    flex-direction: column;
    gap: var(--stack-space);
  }

  .stack[data-space='xs'] {
    --stack-space: var(--space-xs);
  }

  .stack[data-space='s'] {
    --stack-space: var(--space-s);
  }

  .stack[data-space='m'] {
    --stack-space: var(--space-m);
  }

  .stack[data-space='l'] {
    --stack-space: var(--space-l);
  }

  .stack[data-space='xl'] {
    --stack-space: var(--space-xl);
  }
</style>
